import { C } from "../common/component";
import { EditControlBuilder } from "../forms/edit-control-builder";
import { EditControl } from "../forms/form-row";
import { PanelButton, PanelFilterInfo } from "./panels/dashboard-panel";
import { Form, FormDisplayer } from "../forms/form";
import { Loader } from "../common/loader";
import { Requester } from "../common/requester";
import { DownloadHelper } from "../common/download-helper";

export interface DashboardPanelButton {
    name: string;
    onClick: () => Promise<void>;
}

export class DashboardHelper
{
    public static async addFiltersRow(filtersInfo: PanelFilterInfo[], parent, onFiltersChange)
    {
        const filterControls = {};
        const filtersRow = C.div.addClass("row statistics-row").appendTo(parent);
        for (const filter of filtersInfo)
        {
            const control: EditControl = EditControlBuilder.create(filter.TypeData, null, fieldName =>
            {
                const filterControl = filterControls[fieldName];
                return filterControl ? filterControl.getValue() : null;
            }, filter.DisplayName);
            const column = C.div.addClass(`col-md-${12 / filtersInfo.length}`).appendTo(filtersRow);
            control.initialize(column[0]);
            await control.setValue(null);
            control.onChange(onFiltersChange);
            filterControls[filter.Name] = control;
        }
        return filterControls;
    }

    public static getButtons(buttons: PanelButton[], onDataChanged?: () => void): DashboardPanelButton[]
    {
        const result: DashboardPanelButton[] = [];
        for (const button of buttons)
        {
            result.push({
                name: button.Name, onClick: async () =>
                {
                    if (!button.IsDownload)
                    {
                        const form = new Form(button.Url);
                        form.onDataChanged = onDataChanged;
                        await FormDisplayer.openInModal(form);
                    }
                    else
                    {
                        try
                        {
                            Loader.startGlobally();
                            DownloadHelper.download(await Requester.get(button.Url));
                        }
                        finally
                        {
                            Loader.stopGlobally();
                        }

                    }
                }
            });
        }
        return result;
    }
}
